<template>
  <div
    class="flex flex-col mt-6 sm:mt-8 w-full"
    :class="{ 'sm:flex-row sm:items-center sm:justify-start sm:space-y-0 sm:space-x-6': !isStacked }"
  >
    <div
      v-if="post.published_at && !removePublishedDate"
      class="text-sm theme-text-main"
    >
      <span class="font-medium">{{ $t('symptoms-and-conditions.published') }}</span>
      {{ $t('symptoms-and-conditions.on') }}
      <time>
        {{ formatDate(post.published_at) }}
      </time>
    </div>

    <div
      v-if="post.updated_at"
      class="text-sm theme-text-main"
    >
      <span class="font-medium"> {{ $t('symptoms-and-conditions.last-update') }}</span>
      {{ $t('symptoms-and-conditions.on') }}
      <time>
        {{ formatDate(post.updated_at) }}
      </time>
      <template v-if="removePublishedDate">
        <fa
          v-tippy="{
            interactive: true,
            flipDuration: 0,
            popperOptions: {
              modifiers: {
                preventOverflow: {
                  enabled: true,
                },
              },
            },
          }"
          :icon="['fal', 'circle-info']"
          :content="tooltipContent"
        />
      </template>
    </div>

    <div class="mt-2 sm:mt-4 text-sm theme-text-light flex flex-row space-x-6">
      <div class="flex items-center justify-start space-x-1">
        <div class="w-4">
          <fa :icon="['fal', 'clock']" />
        </div>
        <span>{{ $t('blogpost.min-read', { mins: post.read_time }) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon';

export default {
  name: 'VetsterPublishDate',

  props: {
    isStacked: {
      type: Boolean,
      default: true,
    },
    post: {
      type: Object,
      required: true,
    },
  },

  computed: {
    removePublishedDate() {
      return this.$statsig.ready && this.$statsig.checkGate('content_remove_published_date');
    },
    tooltipContent() {
      return '<a class="font-bold underline" href="#" target="_blank">Learn more</a> about publishing and content changes on Vetster.';
    },
  },

  methods: {
    formatDate(isoDate) {
      return DateTime.fromISO(isoDate).toFormat('MMMM dd, yyyy');
    },
  },
};
</script>
